import { Input } from "../../ui/input";

export function PercentField({
  item,
  value,
  error,
  helperText,
  disabled,
  onChange,
  onBlur,
  className,
}) {
  const handleChange = (e) => {
    const input = e.target.value;
    const numericValue = input.replace(/[^0-9.-]+/g, "");
    onChange({ target: { value: numericValue } });
  };

  return (
    <div className="relative">
      <Input
        type="text"
        placeholder={item.placeholder || "0.00"}
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
        disabled={disabled}
        className={`${error ? "border-red-500 hover:border-red-500 focus:border-red-500 pr-8" : "border-gray-300 pr-8"} ${
          className || ""
        }`}
      />
      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm">%</span>
    </div>
  );
}
